module.exports = __webpack_public_path__ + "static/media/mail-sent-amico-work.8254edd6.svg";